/**
 * Skip procedure (spec 06 card 3): while the switch is on, entering a procedural chapter (rules reading,
 * roll call, recess) jumps past it and any procedural chapters right after it. A toast says how much was
 * skipped and where playback is now, with Undo (back to where you were, switch off).
 */
import { meetingStore } from "../../stores/meetingStore";
import { toastStore } from "../../stores/toastStore";
import { jumpTo } from "./vimeoClock";
import type { AgendaChapter } from "../../types";

export const chapterAt = (chapters: AgendaChapter[], t: number) => {
  let i = -1;
  for (let k = 0; k < chapters.length; k++) if (chapters[k].start <= t) i = k;
  return i;
};

/** Called when the current chapter changes, or the switch turns on. */
export function skipIfProcedural() {
  const s = meetingStore.getState();
  if (!s.skipProcedure) return;
  const i = chapterAt(s.chapters, s.currentTime);
  if (i < 0 || !s.chapters[i].procedural) return;
  let j = i;
  while (j + 1 < s.chapters.length && s.chapters[j + 1].procedural) j++;
  const next = s.chapters[j + 1];
  if (!next) return; // procedure runs to the end: nothing to skip to
  const from = s.currentTime;
  jumpTo(next.start);
  const min = Math.max(1, Math.round((next.start - from) / 60));
  toastStore.getState().show({
    message: `Skipped ${min} min of procedure. Now at ${next.shortTitle ?? next.title}.`,
    actionLabel: "Undo",
    onAction: () => { meetingStore.getState().setSkipProcedure(false); jumpTo(from); },
  });
}
